const STATUS_LABELS = {
    0: "Chưa thanh toán",
    1: "Đã thanh toán",
    2: "Hoàn thành",
    3: "Thiếu tiền",
};

export class ImportIdpExamFeeModel {
    constructor(rowIndex, row = {}, errors = []) {
        this.rowIndex = rowIndex;
        this.logCode = row.log_code ?? "";
        this.studentCode = row.student_code ?? "";
        const status = row.status;
        this.status =
            STATUS_LABELS[status] !== undefined ? STATUS_LABELS[status] : status ?? "";
        this.errors = Array.isArray(errors) ? errors : Object.values(errors || {});
    }
}
